module.exports = __webpack_public_path__ + "static/img/bottom_img.1672268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom_img.png
// module id = JVep
// module chunks = 1